import React, { useEffect, useRef, useState } from 'react'
import { FormattedMessage, useIntl } from 'react-intl';
import { PLACEHOLDER_MESSAGES } from '../../constants';
import { ErrorMessage, Field, useFormikContext } from 'formik';
import trashIcon from "./img/trash-icon.svg";
import "./styles/CustomFileInput.scss";
import useMediaQuery from 'utils/hooks/useMediaQuery';
import closeIcon from "utils/components/MultiSelect/components/MultiSelectOption/img/close.png";
import { graphql } from 'react-apollo';
import uploadImagesProjectMutation from './mutation';

let tmpFiles = []; /* global variable to store files */

const CustomMainProjectPhoto = ({ uploadImageProject }) => {
  const intl = useIntl()
  const fileInputRef = useRef(null);
  const isMobile = useMediaQuery("(max-width: 992px)");
  const { setFieldValue, values: { mainProjectPhoto } } = useFormikContext();
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [errorMessage, setErrorMessage] = useState("");
  
  const handleFileChange = () => {
    const file = fileInputRef.current.files[0];

    tmpFiles.push({ name: file.name, file: file, filePath: "",})

    if (file) {
      return uploadImageProject({
        variables: {
          file: file,
        },
      }).then(response => {
        const { uploadImageProject } = response.data;
        const { path } = uploadImageProject;
  
        if (path) {
          tmpFiles = tmpFiles.map((item) => {
            if (item.name === file.name) item.filePath = path;
            return item;
          });
  
          setSelectedFiles(tmpFiles);
          setErrorMessage("");
          setFieldValue("mainProjectPhoto", path);
        }
      }).catch(error => {
        const { graphQLErrors } = error;
        const errorMessage = graphQLErrors[0]?.message;
  
        setErrorMessage("ProjectStepForm.step3.field.fileError");
        console.error("Error upload support image/png/jpeg:", errorMessage);
      })
    } else {
      setErrorMessage("ProjectStepForm.step3.field.fileErrorTry");
    }
  };
  
  const handleDeleteSelectedFile = (file) => {
    setSelectedFiles([]);
    setFieldValue("mainProjectPhoto", []);
    if (fileInputRef.current) {
      fileInputRef.current.value = "";
    }
  }

  const triggerFileInput = () => {
    document.getElementById('mainProjectPhoto').click();
  };

  useEffect(() => {
    if (mainProjectPhoto.length > 0) {
      setSelectedFiles([{ name: mainProjectPhoto, filePath: mainProjectPhoto }]);
    } else {
      setSelectedFiles([]);
    }
  }, [mainProjectPhoto]);

  return (
    <div className="step-0-form__selects d-lg-flex">
      <div className="col-12 col-lg-10 px-0 mb-3 mb-lg-0 mx-auto">
        <label
          className="step-0-form__label p-0 m-0 mb-lg-1 font-weight-bold"
          htmlFor="mainProjectPhoto"
        >
          <FormattedMessage
            id="ProjectStepForm.step4.mainImage"
            defaultMessage="Imagen principal del proyecto"
          />
          {"*"}
        </label>
        <div className="form-control bg-transparent d-flex justify-content-between align-items-center position-relative">
          <span className="custom-file-input__file-name project-photos-hidden col-9">
            {selectedFiles.length > 0 ? (
              selectedFiles.map((file, index) => (
                <span key={index} className="d-flex align-items-center">
                  <span className="file-name-text col-11 col-lg-11 d-inline-block">
                    {file.name}
                  </span>
                  <img
                    className="ml-2"
                    src={closeIcon}
                    alt="close-icon"
                    width={9}
                    height={9}
                    onClick={() => handleDeleteSelectedFile(file)}
                  />
                  {index < selectedFiles.length - 1 && ", "}
                </span>
              ))
            ) : (
              <FormattedMessage
                id="ProjectStepForm.step4.mainImage"
                defaultMessage="Imagen principal del proyecto"
              />
            )}
          </span>
          <button
            className="custom-file-input__button-file project-photos-btn-upload border-0 px-3 rounded position-absolute"
            type="button"
            onClick={triggerFileInput}
          >
            <img src={trashIcon} alt="trash-icon" width={18} height={18} />
            {!isMobile && (
              <p className="p-0 m-0 d-inline ml-2">
                <FormattedMessage
                  id="ProjectStepForm.step3.field.selectFileBtn"
                  defaultMessage="Examinar..."
                />
              </p>
            )}
          </button>
        </div>
        <div className="custom-file-input__info step4-project-input__info col-12 text-center mt-3">
          <FormattedMessage
            id="ProjectStepForm.step4.field.info"
            defaultMessage="Por favor, ten en cuenta que solo se aceptan archivos en formato JPEG,PNG de hasta 800 KB"
          />
        </div>
        <input
          ref={fileInputRef}
          id="mainProjectPhoto"
          name="mainProjectPhoto"
          type="file"
          className="d-none"
          placeholder={intl.formatMessage(PLACEHOLDER_MESSAGES.projectPhotos)}
          onChange={handleFileChange}
          accept=".jpeg, .png, .jpg"
          size={800}
        />
        <ErrorMessage
          className="form-error-message"
          component="div"
          name="mainProjectPhoto"
        />
        {errorMessage && (
          <span className="form-error-message">
            <FormattedMessage id={errorMessage} />
          </span>
        )}
      </div>
    </div>
  );
}

export default graphql(uploadImagesProjectMutation, { name: "uploadImageProject" })(CustomMainProjectPhoto);
